import Hero from "@/components/Hero";
import FeaturedProperties from "@/components/home/FeaturedProperties";
import WhyChooseUs from "@/components/home/WhyChooseUs";
import PropertyTypes from "@/components/home/PropertyTypes";
import Testimonials from "@/components/home/Testimonials";
import FeaturedLocations from "@/components/home/FeaturedLocations";
import CallToAction from "@/components/home/CallToAction";
import { usePropertyTypes } from "@/hooks/usePropertyTypes";
import {
  useProvinces,
  useDistrictsByProvinceId,
  useCitiesByDistrictId,
} from "@/hooks/useLocations";
import { SearchProvider } from "@/context/SearchContext";

// On the homepage, trigger API prefetch of propertyTypes and locations for global cache
const Index = () => {
  // Query hooks fetch data and cache in background for other components
  usePropertyTypes();
  useProvinces();
  useDistrictsByProvinceId(undefined);
  useCitiesByDistrictId(undefined);

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow">
        <SearchProvider>
          {/* Hero Section */}
          <Hero />
        </SearchProvider>

        {/* Featured Properties */}
        <FeaturedProperties />

        {/* Why Choose Us Section */}
        <WhyChooseUs />

        {/* Property Types */}
        <PropertyTypes />

        {/* Testimonials */}
        <Testimonials />

        {/* Featured Locations */}
        <FeaturedLocations />

        {/* CTA Section */}
        <CallToAction />
      </main>
    </div>
  );
};

export default Index;
